var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('BarraCrud',{attrs:{"botaoNovo":true,"onFiltrar":_vm.filtrar,"onNovo":_vm.onNovo}}),_c('UsuariosTable',{ref:"usuariosTableComp",attrs:{"filtro":_vm.filtro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }